import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-deposit-amount-modal',
  templateUrl: './deposit-amount-modal.component.html',
  styleUrls: ['./deposit-amount-modal.component.scss']
})
export class DepositAmountModalComponent implements OnInit {

  @Input('data') data:any;

  constructor(private modalController: ModalController) { }

  ngOnInit(): void {
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  refresh(){
    window?.location?.reload();
  }
}
